"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js"));

var _cust = require("@/api/cust");

var _contractUserShop = require("@/api/contractUserShop");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Dashboard',
  data: function data() {
    return {
      orderStats: {},
      deliveryStats: {},
      installationStats: {},
      modifySupplementStats: {
        pending: 0,
        auditIds: [],
        assign: 0,
        assignIds: []
      },
      customerStats: {
        following: 0,
        noOrder: 0,
        ordered: 0,
        completed: 0,
        afterSales: 0,
        todayPlanNum: 0,
        tomorrowPlanNum: 0
      },
      contractStats: {}
    };
  },
  mounted: function mounted() {
    this.fetchDashboardData();
  },
  methods: {
    fetchDashboardData: function fetchDashboardData() {
      var self = this;
      (0, _cust.getIndexTitle)().then(function (res) {
        // 兼容 request 返回两种形式：{ code, data } 或直接 data
        var data = res && (res.data || res) || {}; // 调试：打印后端返回的数据，帮助定位 today/tomorrow 字段名

        try {
          console.debug('[Dashboard] getIndexTitle data:', data);
        } catch (e) {}

        self.orderStats = {
          total: data.orderInfo && data.orderInfo.total || 0,
          pending: data.orderInfo && data.orderInfo.unsubmitted || 0,
          unpaid: data.orderInfo && data.orderInfo.pendingDealerConfirm || 0,
          inbound: data.orderInfo && data.orderInfo.pendingQuoteAudit || 0,
          instocked: data.orderInfo && (data.orderInfo.partialStocked || data.orderInfo.fullyStocked) || 0
        };
        self.deliveryStats = {
          total: data.shipInfo && data.shipInfo.total || 0,
          pendingAppointment: data.shipInfo && data.shipInfo.pendingAppointment || 0,
          pendingDelivery: data.shipInfo && data.shipInfo.pendingDelivery || 0,
          pendingReceipt: data.shipInfo && data.shipInfo.pendingReceipt || 0,
          completed: data.shipInfo && data.shipInfo.completed || 0
        };
        self.installationStats = {
          total: data.installInfo && data.installInfo.total || 0,
          pendingSubmit: data.installInfo && data.installInfo.pendingSubmit || 0,
          pendingInstall: data.installInfo && data.installInfo.pendingInstall || 0,
          installing: data.installInfo && data.installInfo.installing || 0,
          completed: data.installInfo && data.installInfo.completed || 0
        }; // 合并客户统计并保证字段存在

        self.customerStats = Object.assign({}, self.customerStats, {
          following: data.custInfo && (data.custInfo.follow_up || data.custInfo.following) || 0,
          noOrder: data.custInfo && (data.custInfo.unordered || data.custInfo.noOrder) || 0,
          ordered: data.custInfo && (data.custInfo.ordered || 0) || 0,
          completed: data.custInfo && (data.custInfo.completed || 0) || 0,
          afterSales: data.custInfo && (data.custInfo.after_sales || data.custInfo.afterSales) || 0,
          todayPlanNum: data.custInfo && (data.custInfo.todayPlanNum || data.custInfo.today_plan_num || data.custInfo.today_plan || data.custInfo.todayPlan) || 0,
          tomorrowPlanNum: data.custInfo && (data.custInfo.tomorrowPlanNum || data.custInfo.tomorrow_plan_num || data.custInfo.tomorrow_plan || data.custInfo.tomorrowPlan) || 0
        }); // 使用 $set 确保响应式更新（防止替换对象导致模板不更新）

        try {
          var t = data.custInfo && (data.custInfo.todayPlanNum || data.custInfo.today_plan_num || data.custInfo.today_plan || data.custInfo.todayPlan) || 0;
          var tm = data.custInfo && (data.custInfo.tomorrowPlanNum || data.custInfo.tomorrow_plan_num || data.custInfo.tomorrow_plan || data.custInfo.tomorrowPlan) || 0;
          self.$set(self.customerStats, 'todayPlanNum', t);
          self.$set(self.customerStats, 'tomorrowPlanNum', tm);
          console.debug('[Dashboard] merged customerStats:', self.customerStats);
        } catch (e) {
          console.error('[Dashboard] set customerStats error', e);
        } // 合同管理数据（按图中 11 个状态）


        self.contractStats = {
          pendingSign: data.contractInfo && data.contractInfo.pendingSign || 0,
          signed: data.contractInfo && data.contractInfo.signed || 0,
          pendingDesign: data.contractInfo && data.contractInfo.pendingDesign || 0,
          pendingOrder: data.contractInfo && data.contractInfo.pendingOrder || 0,
          pendingAudit: data.contractInfo && data.contractInfo.pendingAudit || 0,
          splitAudit: data.contractInfo && data.contractInfo.splitAudit || 0,
          quoteAudit: data.contractInfo && data.contractInfo.quoteAudit || 0,
          dealerConfirm: data.contractInfo && data.contractInfo.dealerConfirm || 0,
          financeAudit: data.contractInfo && data.contractInfo.financeAudit || 0,
          partialIn: data.contractInfo && data.contractInfo.partialIn || 0,
          fullyIn: data.contractInfo && data.contractInfo.fullyIn || 0
        };
      }).catch(function (err) {
        console.error('获取首页数据失败', err);
      }); // 待处理改补订单数量

      (0, _contractUserShop.countPendingList)().then(function (res) {
        var count = 0;
        var ids = [];

        if (res && res.code === 200) {
          var val = res.data;

          if (typeof val === 'number') {
            count = val;
          } else if (Array.isArray(val)) {
            count = val.length;
            ids = val;
          } else if (val && (0, _typeof2.default)(val) === 'object') {
            count = val.pending || val.count || val.total || 0;
          }
        } else if (res && typeof res === 'number') {
          count = res;
        }

        self.$set(self.modifySupplementStats, 'pending', count);
        self.$set(self.modifySupplementStats, 'auditIds', ids);
      }).catch(function (err) {
        console.error('获取改补订单数量失败', err);
      }); // 指派处理改补订单数量

      (0, _contractUserShop.countAssignList)().then(function (res) {
        var count = 0;
        var ids = [];

        if (res && res.code === 200) {
          var val = res.data;

          if (typeof val === 'number') {
            count = val;
          } else if (Array.isArray(val)) {
            count = val.length;
            ids = val;
          } else if (val && (0, _typeof2.default)(val) === 'object') {
            count = val.pending || val.count || val.total || 0;
          }
        } else if (res && typeof res === 'number') {
          count = res;
        }

        self.$set(self.modifySupplementStats, 'assign', count);
        self.$set(self.modifySupplementStats, 'assignIds', ids);
      }).catch(function (err) {
        console.error('获取指派处理订单数量失败', err);
      });
    },
    goToOrders: function goToOrders(filter) {
      if (filter) {
        this.$router.push({
          path: '/orders',
          query: {
            filter: filter
          }
        });
      } else {
        this.$router.push('/orders');
      }
    },
    goToContracts: function goToContracts(status) {
      if (status) {
        this.$router.push({
          path: '/orders',
          query: {
            contractStatus: status
          }
        });
      } else {
        this.$router.push('/orders');
      }
    },
    goToDelivery: function goToDelivery(status) {
      if (status) {
        this.$router.push({
          path: '/delivery',
          query: {
            status: status
          }
        });
      } else {
        this.$router.push('/delivery');
      }
    },
    goToInstallation: function goToInstallation(status) {
      if (status) {
        this.$router.push({
          path: '/install',
          query: {
            status: status
          }
        });
      } else {
        this.$router.push('/install');
      }
    },
    goToCustomers: function goToCustomers(status) {
      if (status === '今日测量' || status === '明日测量') {
        var today = new Date();

        var pad = function pad(n) {
          return n < 10 ? '0' + n : n;
        };

        var formatDate = function formatDate(d) {
          return "".concat(d.getFullYear(), "-").concat(pad(d.getMonth() + 1), "-").concat(pad(d.getDate()));
        };

        var begin, end;

        if (status === '今日测量') {
          var dstr = formatDate(today);
          begin = dstr + ' 00:00:00';
          end = dstr + ' 23:59:59';
        } else {
          var tm = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);

          var _dstr = formatDate(tm);

          begin = _dstr + ' 00:00:00';
          end = _dstr + ' 23:59:59';
        }

        this.$router.push({
          path: '/customers',
          query: {
            planMeasureTimeBegin: begin,
            planMeasureTimeEnd: end
          }
        });
      } else if (status) {
        this.$router.push({
          path: '/customers',
          query: {
            status: status
          }
        });
      } else {
        this.$router.push('/customers');
      }
    },
    goToModifySupplement: function goToModifySupplement() {
      var ids = this.modifySupplementStats.auditIds || [];

      if (ids.length > 0) {
        this.$router.push({
          path: '/modifySupplement/index',
          query: {
            auditIds: ids.join(',')
          }
        });
      } else {
        this.$router.push('/modifySupplement/index');
      }
    },
    goToModifySupplementAssign: function goToModifySupplementAssign() {
      var ids = this.modifySupplementStats.assignIds || [];

      if (ids.length > 0) {
        this.$router.push({
          path: '/modifySupplement/index',
          query: {
            auditIds: ids.join(',')
          }
        });
      } else {
        this.$router.push('/modifySupplement/index');
      }
    }
  }
};
exports.default = _default;